import { AppDispatch, GetAppState } from '../../store';
import { libraryManagedConfig } from '../../config';
import { buildBulkRequestPathParamsAndData, deselectAll } from '../../store/productSelection/actions';
import * as consts from '../../store/constants';
import { globalErrorResponse, showNotification, TYPE_WARNING } from '../../store/notifications/actions';
import { getAgeCategoryParam } from '../../store/ageCategory/actions';
import i18n from '../../../i18n';
import { http } from '../axios';

export function addProductsToGroup(productGroupId: number) {
    return (dispatch: AppDispatch, state: GetAppState) => {
        const endpoint = libraryManagedConfig().endpointProductGroupBulkSource;
        let requestdata;
        try {
            requestdata = buildBulkRequestPathParamsAndData(consts.ACTION_COPY, 1, state, false);
        } catch (error) {
            dispatch(showNotification(i18n.t('notifications.addProductsToGroup.warning'), TYPE_WARNING));
            return;
        }
        const pathParams = requestdata.pathParams;
        pathParams.productGroupId = productGroupId;

        const ageCategory = getAgeCategoryParam(state);
        const params = { ageCategory: ageCategory ? ageCategory : undefined };

        const payload = requestdata.data;

        http.put(endpoint, payload, { pathParams, params })
            .then(() => {
                dispatch(deselectAll());
                dispatch(showNotification(i18n.t('notifications.addProductsToGroup.success')));
            })
            .catch(error => dispatch(globalErrorResponse(error)));
    };
}
